import DocumentView from './DocumentView.provider';

export default DocumentView;
